let BASE_URL = "https://cipl.aimantra.info";
// BASE_URL = "https://5rn0m63d-8000.inc1.devtunnels.ms";
// BASE_URL = 'https://csms.aimantra.info';
// BASE_URL = 'https://6mpwdglt-8000.inc1.devtunnels.ms'

const BASE_URL2 = "https://bd.aimantra.info";
const BASE_URL3 = "https://hrms.aimantra.info";


// let BASE_URL = "https://n00nmkv7-8002.inc1.devtunnels.ms";
// BASE_URL = "https://n00nmkv7-8005.inc1.devtunnels.ms";
// BASE_URL = "https://n00nmkv7-8000.inc1.devtunnels.ms";
//@G-ENG
// let BASE_URL = "https://g-eng.aimantra.info";
//@SC
// let BASE_URL = "https://sc.aimantra.info";
//@Tester Lenovo
// let BASE_URL = "https://1dmjlcrf-8000.inc1.devtunnels.ms";

const currentUrl = window.location.href;
const urlParts = currentUrl.split("/");
const FRONTEND_URL = urlParts[0] + `//` + urlParts[2];

const domainParts = urlParts[2].split(".");
console.log(domainParts);
let client = domainParts[1];

if (domainParts[1] === "aimantra") {
  client = domainParts[0];
  console.log("client0");
}
console.log("client1");
console.log(client);

let IMAGE_URL = "https://cipl-aimant ra.s3.ap-south-1.amazonaws.com/";
let TESTING_URL = "https://n00nmkv7-8005.inc1.devtunnels.ms";
let TESTING_URL_actual = "https://cipl.aimantra.info";

  BASE_URL = "https://labmonitoring.aimantra.info";
  // BASE_URL = "https://bkzrdhbv-8008.inc1.devtunnels.ms";
  // BASE_URL = "https://staging.aimantra.info";
  console.log("BASE_URL C");
  console.log(BASE_URL);

switch (client) {
  case "cipl":
    IMAGE_URL = "https://cipl-aimantra.s3.ap-south-1.amazonaws.com/";
    break;
  case "g-eng":
    IMAGE_URL = "https://geng-aimantra.s3.ap-south-1.amazonaws.com/";
    break;
  case "sc":
    IMAGE_URL = "https://spacecreator-aimantra.s3.ap-south-1.amazonaws.com/";
    break;
  case "csms":
    IMAGE_URL = "https://cipl-aimantra.s3.ap-south-1.amazonaws.com/";
    break;
  case "almondz":
    IMAGE_URL = "https://cipl-aimantra.s3.ap-south-1.amazonaws.com/";
    break;
  default:
    IMAGE_URL = "https://cipl-aimantra.s3.ap-south-1.amazonaws.com/";
    break;
}

const AUTH = {
  headers: {
    Authorization: sessionStorage.getItem("access_token")
      ? "Bearer " + sessionStorage.getItem("access_token")
      : null,
    "Content-Type": "application/json",
    accept: "application/json",
  },
};

const AUTHH = {
  headers: {
    Authorization: sessionStorage.getItem("access_token")
      ? "Bearer " + sessionStorage.getItem("access_token")
      : null,
    "Content-Type": "multipart/form-data",
  },
};

export {
  BASE_URL,
  AUTH,
  AUTHH,
  FRONTEND_URL,
  IMAGE_URL,
  TESTING_URL,
  TESTING_URL_actual,
  BASE_URL2,
  BASE_URL3,
};
